export const DEFAULT_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = ["en", "hi"];

export function normalizeLanguage(value) {
  const normalizedValue = String(value || "")
    .trim()
    .toLowerCase()
    .split("-")[0];

  if (SUPPORTED_LANGUAGES.includes(normalizedValue)) {
    return normalizedValue;
  }

  return DEFAULT_LANGUAGE;
}

export function detectInitialLanguage() {
  if (typeof window === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  const browserLanguage =
    navigator.languages?.[0] || navigator.language || DEFAULT_LANGUAGE;

  return normalizeLanguage(browserLanguage);
}
